import { apiClient } from '@/services/ApiClient.js'

export default {
  getOrderComments(id) {
    return apiClient
      .get('orders/' + id + '/comments')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getOrderComment(orderId, commentId) {
    return apiClient
      .get('orders/' + orderId + '/comments/' + commentId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createOrderComment(orderId, params) {
    return apiClient
      .post('orders/' + orderId + '/comments/', params)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  editOrderComment(orderId, commentId, comment) {
    return apiClient
      .patch('orders/' + orderId + '/comments/' + commentId, comment)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  deleteOrderComment(orderId, commentId) {
    return apiClient
      .delete('orders/' + orderId + '/comments/' + commentId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getRetailerComments(id) {
    return apiClient
      .get('retailers/' + id + '/comments')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getRetailerComment(retailerId, commentId) {
    return apiClient
      .get('retailers/' + retailerId + '/comments/' + commentId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createRetailerComment(retailerId, comment) {
    return apiClient
      .post('retailers/' + retailerId + '/comments/', comment)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  editRetailerComment(retailerId, commentId, comment) {
    return apiClient
      .patch('retailers/' + retailerId + '/comments/' + commentId, comment)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  deleteRetailerComment(retailerId, commentId) {
    return apiClient
      .delete('retailers/' + retailerId + '/comments/' + commentId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getFarmerComments(id) {
    return apiClient
      .get('farmers/' + id + '/comments')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getFarmerComment(farmerId, commentId) {
    return apiClient
      .get('farmers/' + farmerId + '/comments/' + commentId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createFarmerComment(farmerId, comment) {
    return apiClient
      .post('farmers/' + farmerId + '/comments/', comment)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  editFarmerComment(farmerId, commentId, comment) {
    return apiClient
      .patch('farmers/' + farmerId + '/comments/' + commentId, comment)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  deleteFarmerComment(farmerId, commentId) {
    return apiClient
      .delete('farmers/' + farmerId + '/comments/' + commentId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getApplicationComments(id) {
    return apiClient
      .get('applications/' + id + '/comments')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getApplicationComment(applicationId, commentId) {
    return apiClient
      .get('applications/' + applicationId + '/comments' + commentId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createApplicationComment(applicationId, comment) {
    return apiClient
      .post('applications/' + applicationId + '/comments', comment)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  editApplicationComment(applicationId, commentId, comment) {
    return apiClient
      .patch('applications/' + applicationId + '/comments/' + commentId, comment)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  deleteApplicationComment(applicationId, commentId) {
    return apiClient
      .delete('applications/' + applicationId + '/comments/' + commentId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getSupplierComments(id) {
    return apiClient
      .get('suppliers/' + id + '/comments')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createSupplierComment(supplierId, comment) {
    return apiClient
      .post('suppliers/' + supplierId + '/comments', comment)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  deleteSupplierComment(supplierId, commentId) {
    return apiClient
      .delete('suppliers/' + supplierId + '/comments/' + commentId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
